import { render, staticRenderFns } from "./addTerminal.vue?vue&type=template&id=2d0739bf"
import script from "./addTerminal.vue?vue&type=script&lang=js"
export * from "./addTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports